module.exports = __webpack_public_path__ + "static/media/icono4.bec6c017.png";